import getIsRTLLanguage from 'utils/common/isRTL';



/**
 * Scroll a child element into view within a scrollable container.
 *
 * Supports both vertical and horizontal scrolling.
 *
 * Uses manual scroll position calculations instead of
 * scrollIntoView({ block: 'nearest' }) because old Tizen WebKit
 * only supports the boolean overload of scrollIntoView.
 *
 * @param {HTMLElement | null | undefined} child
 * @param {HTMLElement | null | undefined} [scrollParent]
 * @param {'vertical' | 'horizontal'} [axis='vertical']
 * @param {number} [edgePadding=5]
 */
export function scrollChildIntoView(child,scrollParent,axis = 'vertical',edgePadding = 5) {
    if (!child) {
        return;
    }

    const container = scrollParent ?? child.parentNode;

    if (!container) {
        return;
    }

    const elRect = child.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    if (axis === 'horizontal') {
        const elLeft =
            elRect.left -
            containerRect.left +
            container.scrollLeft;

        const elRight = elLeft + elRect.width;

        const visibleLeft = container.scrollLeft;
        const visibleRight =
            visibleLeft + container.clientWidth;

        if (elLeft < visibleLeft) {
            container.scrollLeft =
                elLeft - edgePadding;
        } else if (elRight > visibleRight) {
            container.scrollLeft =
                elRight -
                container.clientWidth +
                edgePadding;
        }

        return;
    }

    const elTop =
        elRect.top -
        containerRect.top +
        container.scrollTop;

    const elBottom = elTop + elRect.height;

    const visibleTop = container.scrollTop;
    const visibleBottom =
        visibleTop + container.clientHeight;

    if (elTop < visibleTop) {
        container.scrollTop =
            elTop - edgePadding;
    } else if (elBottom > visibleBottom) {
        container.scrollTop =
            elBottom -
            container.clientHeight +
            edgePadding;
    }
}

export function scrollIntoView(selector, index) {
    const items = document.querySelectorAll(selector);
    const item = items[index ?? 0];
    if (!item) {
        return;
    }

    const container = item.parentElement;
    const itemLeft = item.offsetLeft;
    const itemWidth = item.offsetWidth;

    const remainWidth = Math.floor((container.offsetWidth - itemWidth) / 2);
    let scrollLeft = itemLeft - remainWidth;

    if (getIsRTLLanguage()) {
        // For RTL, we need to calculate from the right edge
        // The scroll position should be the total scrollable width minus the desired position
        const maxScrollLeft = container.scrollWidth - container.clientWidth;
        const rightPosition = container.scrollWidth - (itemLeft + itemWidth);
        scrollLeft = maxScrollLeft - (rightPosition - remainWidth);
    }

    container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
    });
}